module.exports = __webpack_public_path__ + "static/img/14.2fddd89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/14.png
// module id = ln+S
// module chunks = 0